import {
  Companion_getInstance3ar1by5trsbn7 as Companion_getInstance,
  ProjectSettlementDocumentation1o22wkmr8w8uo as ProjectSettlementDocumentation,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AccessInfoj60d6hx1qs8r as AccessInfo } from './supportModels.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectSettlementDocumentation_project_getInstance());
}
function prepareProjectSettlementDocumentationFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ProjectSettlementDocumentation__id_getInstance(), ProjectSettlementDocumentation_project_getInstance(), ProjectSettlementDocumentation_submitted_getInstance(), ProjectSettlementDocumentation_submittedByClient_getInstance(), ProjectSettlementDocumentation_summary_getInstance(), ProjectSettlementDocumentation_documents_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ProjectSettlementDocumentation_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ProjectSettlementDocumentation_project$_get_name_$ref_r8bm4f() {
  return (p0) => p0.k20();
}
function ProjectSettlementDocumentation_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectSettlementDocumentation_project$_get_serializer_$ref_r5y8x2() {
  return (p0) => p0.j2j();
}
function ProjectSettlementDocumentation_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ProjectSettlementDocumentation_project$_get_annotations_$ref_5uu39y() {
  return (p0) => p0.bz();
}
var ProjectSettlementDocumentation_projectClass;
function ProjectSettlementDocumentation_project() {
  if (ProjectSettlementDocumentation_projectClass === VOID) {
    class $ {
      constructor() {
        ProjectSettlementDocumentation_project_instance = this;
        var tmp = this;
        tmp.d7s_1 = lazy(ProjectSettlementDocumentation_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e7s_1 = lazy(ProjectSettlementDocumentation_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f7s_1 = lazy(ProjectSettlementDocumentation_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.d7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectSettlementDocumentation_project$_get_name_$ref_r8bm4f(), null);
        return tmp0.f2();
      }
      g7s(receiver) {
        return receiver.i7s_1;
      }
      m2j(receiver) {
        return this.g7s(receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE());
      }
      n7s(receiver, value) {
        return receiver.o7s(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE();
        return this.n7s(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectSettlementDocumentation_project$_get_serializer_$ref_r5y8x2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectSettlementDocumentation_project$_get_annotations_$ref_5uu39y(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectSettlementDocumentation_project', VOID, VOID, [SerializableProperty()]);
    ProjectSettlementDocumentation_projectClass = $;
  }
  return ProjectSettlementDocumentation_projectClass;
}
var ProjectSettlementDocumentation_project_instance;
function ProjectSettlementDocumentation_project_getInstance() {
  if (ProjectSettlementDocumentation_project_instance === VOID)
    new (ProjectSettlementDocumentation_project())();
  return ProjectSettlementDocumentation_project_instance;
}
function ProjectSettlementDocumentation__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ProjectSettlementDocumentation__id$_get_name_$ref_tocs8w() {
  return (p0) => p0.k20();
}
function ProjectSettlementDocumentation__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectSettlementDocumentation__id$_get_serializer_$ref_wqelzt() {
  return (p0) => p0.j2j();
}
function ProjectSettlementDocumentation__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ProjectSettlementDocumentation__id$_get_annotations_$ref_47b3nv() {
  return (p0) => p0.bz();
}
var ProjectSettlementDocumentation__idClass;
function ProjectSettlementDocumentation__id() {
  if (ProjectSettlementDocumentation__idClass === VOID) {
    class $ {
      constructor() {
        ProjectSettlementDocumentation__id_instance = this;
        var tmp = this;
        tmp.p7s_1 = lazy(ProjectSettlementDocumentation__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q7s_1 = lazy(ProjectSettlementDocumentation__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r7s_1 = lazy(ProjectSettlementDocumentation__id$annotations$delegate$lambda);
        this.s7s_1 = Companion_getInstance_0().m2p();
        this.t7s_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.p7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectSettlementDocumentation__id$_get_name_$ref_tocs8w(), null);
        return tmp0.f2();
      }
      g7s(receiver) {
        return receiver.h7s_1;
      }
      m2j(receiver) {
        return this.g7s(receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE());
      }
      n7s(receiver, value) {
        return receiver.o7s(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE();
        return this.n7s(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectSettlementDocumentation__id$_get_serializer_$ref_wqelzt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectSettlementDocumentation__id$_get_annotations_$ref_47b3nv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectSettlementDocumentation__id', VOID, VOID, [SerializableProperty()]);
    ProjectSettlementDocumentation__idClass = $;
  }
  return ProjectSettlementDocumentation__idClass;
}
var ProjectSettlementDocumentation__id_instance;
function ProjectSettlementDocumentation__id_getInstance() {
  if (ProjectSettlementDocumentation__id_instance === VOID)
    new (ProjectSettlementDocumentation__id())();
  return ProjectSettlementDocumentation__id_instance;
}
function ProjectSettlementDocumentation_submitted$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ProjectSettlementDocumentation_submitted$_get_name_$ref_v696sh() {
  return (p0) => p0.k20();
}
function ProjectSettlementDocumentation_submitted$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectSettlementDocumentation_submitted$_get_serializer_$ref_7o2n0o() {
  return (p0) => p0.j2j();
}
function ProjectSettlementDocumentation_submitted$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ProjectSettlementDocumentation_submitted$_get_annotations_$ref_uahbt8() {
  return (p0) => p0.bz();
}
var ProjectSettlementDocumentation_submittedClass;
function ProjectSettlementDocumentation_submitted() {
  if (ProjectSettlementDocumentation_submittedClass === VOID) {
    class $ {
      constructor() {
        ProjectSettlementDocumentation_submitted_instance = this;
        var tmp = this;
        tmp.u7s_1 = lazy(ProjectSettlementDocumentation_submitted$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v7s_1 = lazy(ProjectSettlementDocumentation_submitted$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w7s_1 = lazy(ProjectSettlementDocumentation_submitted$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.u7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectSettlementDocumentation_submitted$_get_name_$ref_v696sh(), null);
        return tmp0.f2();
      }
      g7s(receiver) {
        return receiver.j7s_1;
      }
      m2j(receiver) {
        return this.g7s(receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE());
      }
      x7s(receiver, value) {
        return receiver.o7s(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE();
        return this.x7s(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectSettlementDocumentation_submitted$_get_serializer_$ref_7o2n0o(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectSettlementDocumentation_submitted$_get_annotations_$ref_uahbt8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectSettlementDocumentation_submitted', VOID, VOID, [SerializableProperty()]);
    ProjectSettlementDocumentation_submittedClass = $;
  }
  return ProjectSettlementDocumentation_submittedClass;
}
var ProjectSettlementDocumentation_submitted_instance;
function ProjectSettlementDocumentation_submitted_getInstance() {
  if (ProjectSettlementDocumentation_submitted_instance === VOID)
    new (ProjectSettlementDocumentation_submitted())();
  return ProjectSettlementDocumentation_submitted_instance;
}
function ProjectSettlementDocumentation_submittedByClient$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ProjectSettlementDocumentation_submittedByClient$_get_name_$ref_23r7y5() {
  return (p0) => p0.k20();
}
function ProjectSettlementDocumentation_submittedByClient$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectSettlementDocumentation_submittedByClient$_get_serializer_$ref_vpevai() {
  return (p0) => p0.j2j();
}
function ProjectSettlementDocumentation_submittedByClient$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ProjectSettlementDocumentation_submittedByClient$_get_annotations_$ref_4jx8wi() {
  return (p0) => p0.bz();
}
var ProjectSettlementDocumentation_submittedByClientClass;
function ProjectSettlementDocumentation_submittedByClient() {
  if (ProjectSettlementDocumentation_submittedByClientClass === VOID) {
    class $ {
      constructor() {
        ProjectSettlementDocumentation_submittedByClient_instance = this;
        var tmp = this;
        tmp.y7s_1 = lazy(ProjectSettlementDocumentation_submittedByClient$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z7s_1 = lazy(ProjectSettlementDocumentation_submittedByClient$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a7t_1 = lazy(ProjectSettlementDocumentation_submittedByClient$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.y7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectSettlementDocumentation_submittedByClient$_get_name_$ref_23r7y5(), null);
        return tmp0.f2();
      }
      g7s(receiver) {
        return receiver.k7s_1;
      }
      m2j(receiver) {
        return this.g7s(receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE());
      }
      b7t(receiver, value) {
        return receiver.o7s(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE();
        return this.b7t(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z7s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectSettlementDocumentation_submittedByClient$_get_serializer_$ref_vpevai(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectSettlementDocumentation_submittedByClient$_get_annotations_$ref_4jx8wi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectSettlementDocumentation_submittedByClient', VOID, VOID, [SerializableProperty()]);
    ProjectSettlementDocumentation_submittedByClientClass = $;
  }
  return ProjectSettlementDocumentation_submittedByClientClass;
}
var ProjectSettlementDocumentation_submittedByClient_instance;
function ProjectSettlementDocumentation_submittedByClient_getInstance() {
  if (ProjectSettlementDocumentation_submittedByClient_instance === VOID)
    new (ProjectSettlementDocumentation_submittedByClient())();
  return ProjectSettlementDocumentation_submittedByClient_instance;
}
function ProjectSettlementDocumentation_summary$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ProjectSettlementDocumentation_summary$_get_name_$ref_4plw4() {
  return (p0) => p0.k20();
}
function ProjectSettlementDocumentation_summary$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectSettlementDocumentation_summary$_get_serializer_$ref_miixoz() {
  return (p0) => p0.j2j();
}
function ProjectSettlementDocumentation_summary$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ProjectSettlementDocumentation_summary$_get_annotations_$ref_3qvj9l() {
  return (p0) => p0.bz();
}
var ProjectSettlementDocumentation_summaryClass;
function ProjectSettlementDocumentation_summary() {
  if (ProjectSettlementDocumentation_summaryClass === VOID) {
    class $ {
      constructor() {
        ProjectSettlementDocumentation_summary_instance = this;
        var tmp = this;
        tmp.c7t_1 = lazy(ProjectSettlementDocumentation_summary$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d7t_1 = lazy(ProjectSettlementDocumentation_summary$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e7t_1 = lazy(ProjectSettlementDocumentation_summary$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.c7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectSettlementDocumentation_summary$_get_name_$ref_4plw4(), null);
        return tmp0.f2();
      }
      g7s(receiver) {
        return receiver.l7s_1;
      }
      m2j(receiver) {
        return this.g7s(receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE());
      }
      f7t(receiver, value) {
        return receiver.o7s(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE();
        return this.f7t(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectSettlementDocumentation_summary$_get_serializer_$ref_miixoz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectSettlementDocumentation_summary$_get_annotations_$ref_3qvj9l(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectSettlementDocumentation_summary', VOID, VOID, [SerializableProperty()]);
    ProjectSettlementDocumentation_summaryClass = $;
  }
  return ProjectSettlementDocumentation_summaryClass;
}
var ProjectSettlementDocumentation_summary_instance;
function ProjectSettlementDocumentation_summary_getInstance() {
  if (ProjectSettlementDocumentation_summary_instance === VOID)
    new (ProjectSettlementDocumentation_summary())();
  return ProjectSettlementDocumentation_summary_instance;
}
function ProjectSettlementDocumentation_documents$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function ProjectSettlementDocumentation_documents$_get_name_$ref_8ife9q() {
  return (p0) => p0.k20();
}
function ProjectSettlementDocumentation_documents$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectSettlementDocumentation_documents$_get_serializer_$ref_fta3iz() {
  return (p0) => p0.j2j();
}
function ProjectSettlementDocumentation_documents$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function ProjectSettlementDocumentation_documents$_get_annotations_$ref_n3sf07() {
  return (p0) => p0.bz();
}
var ProjectSettlementDocumentation_documentsClass;
function ProjectSettlementDocumentation_documents() {
  if (ProjectSettlementDocumentation_documentsClass === VOID) {
    class $ {
      constructor() {
        ProjectSettlementDocumentation_documents_instance = this;
        var tmp = this;
        tmp.g7t_1 = lazy(ProjectSettlementDocumentation_documents$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h7t_1 = lazy(ProjectSettlementDocumentation_documents$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i7t_1 = lazy(ProjectSettlementDocumentation_documents$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.g7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectSettlementDocumentation_documents$_get_name_$ref_8ife9q(), null);
        return tmp0.f2();
      }
      g7s(receiver) {
        return receiver.m7s_1;
      }
      m2j(receiver) {
        return this.g7s(receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE());
      }
      j7t(receiver, value) {
        return receiver.o7s(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectSettlementDocumentation() ? receiver : THROW_CCE();
        return this.j7t(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectSettlementDocumentation_documents$_get_serializer_$ref_fta3iz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectSettlementDocumentation_documents$_get_annotations_$ref_n3sf07(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectSettlementDocumentation_documents', VOID, VOID, [SerializableProperty()]);
    ProjectSettlementDocumentation_documentsClass = $;
  }
  return ProjectSettlementDocumentation_documentsClass;
}
var ProjectSettlementDocumentation_documents_instance;
function ProjectSettlementDocumentation_documents_getInstance() {
  if (ProjectSettlementDocumentation_documents_instance === VOID)
    new (ProjectSettlementDocumentation_documents())();
  return ProjectSettlementDocumentation_documents_instance;
}
//region block: exports
export {
  prepareProjectSettlementDocumentationFields as prepareProjectSettlementDocumentationFields1rkui3um63log,
  get_project as get_project23k9lsk7gv41f,
};
//endregion

//# sourceMappingURL=ProjectSettlementDocumentationFields.mjs.map
